import { useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { ContactDTO, ContactType, FindAllContactsFilters, FindContactsTargetResponse } from "../../../lib/filters/dto";
import { initialStateContactsFilters } from "../../../lib/filters/filtersSlice";
import { keycloak } from "../../../lib/keycloak";
import { useAppDispatch } from "../../../lib/redux/hooks";
import { TabPages } from "../../../ui/organisms/tabs/tabPages";
import { PersonDTO } from "../../database/people/dto";
import { ProjectDTO } from "../../projects/dto";
import { EmailsMessagesDTO, FindAllCustomMailsResponseDTO } from "../../projects/mails/dto";
import { ContactsCounterDTO, ContactsIdsResponseDTO } from "../contacts/dto";
import { TargetListDTO } from "../dto";
import { TargetListCompanies } from "./companies";
import { Form } from "./form/form";
import { TargetListPeople } from "./people";
import { UpdateTargetListFormValues } from "./validation";

interface Props {
  form: UseFormReturn<UpdateTargetListFormValues>;
  targetContactIds: ContactsIdsResponseDTO[]
  targetList: TargetListDTO
  project: ProjectDTO

  isLoadingEmailsHistory: boolean
  emailsHistory: { messages: EmailsMessagesDTO[] }
  templates: FindAllCustomMailsResponseDTO

  showPopupPeople: boolean
  setShowPopupPeople: (action: boolean) => void
  selectedIdsPeople: { contactId: string, personId: string }[]
  setSelectedIdsPeople: (action: { contactId: string, personId: string }[]) => void

  peopleFilters: FindAllContactsFilters
  setPeopleFilters: (action: Partial<FindAllContactsFilters>) => void
  peopleContacts: FindContactsTargetResponse<ContactType.PERSON>
  toActivatePeople: number
  peopleCounters: ContactsCounterDTO

  showPopupCompanies: boolean
  setShowPopupCompanies: (action: boolean) => void
  selectedIdsCompanies: { contactId: string, companyId: string }[]
  setSelectedIdsCompanies: (action: { contactId: string, companyId: string }[]) => void

  companiesFilters: FindAllContactsFilters
  setCompaniesFilters: (action: Partial<FindAllContactsFilters>) => void
  companiesContacts: {
    total: number
    page: number
    perPage: number
    prev: boolean
    next: boolean
    totalPage: number
    data: { company: ContactDTO<ContactType.COMPANY>, employees: PersonDTO[] }[]
  }
  toActivateCompanies: number
  companiesCounters: ContactsCounterDTO
}

export function EditTargetList(props: Props) {
  const {
    form,
    targetContactIds,
    targetList,
    project,

    isLoadingEmailsHistory,
    emailsHistory,
    templates,

    selectedIdsPeople,
    setSelectedIdsPeople,
    setShowPopupPeople,
    showPopupPeople,
    selectedIdsCompanies,
    setSelectedIdsCompanies,
    setShowPopupCompanies,
    showPopupCompanies,
    peopleFilters,
    peopleContacts,
    setPeopleFilters,
    setCompaniesFilters,
    companiesFilters,
    companiesContacts,

    toActivateCompanies,
    toActivatePeople,
    peopleCounters,
    companiesCounters
  } = props

  const tab = useParams().tab || 'specifics'
  const navigate = useNavigate();

  const [direction, setDirection] = useState<"left" | "right">("left");

  return (
    <div className="h-full max-h-full p-4">
      <div className="flex flex-col bg-white rounded-2xl shadow-sm h-full max-h-full">
        <div
          className="h-full"
        >
          <TabPages
            direction={direction}
            setDirection={(value) => setDirection(value)}
            pages={[
              <div key={0} className="max-h-full h-full overflow-auto">
                <Form
                  project={project}
                  form={form}
                  peopleCounters={peopleCounters?.dto}
                  companiesCounters={companiesCounters?.dto}
                />
              </div>,
              <div key={1} className="h-full">
                <TargetListPeople
                  templates={templates}
                  project={project}
                  targetList={targetList}
                  targetContactIds={targetContactIds}
                  counters={peopleCounters}
                  toActivate={toActivatePeople}
                  contacts={peopleContacts}
                  filters={peopleFilters}
                  setFilters={(action) => setPeopleFilters({ ...peopleFilters, ...action, page: 0 })}
                  setPage={(action) => setPeopleFilters({ ...peopleFilters, page: action })}
                  resetFilters={() => setPeopleFilters(initialStateContactsFilters['target'][ContactType.PERSON])}
                  selectedIds={selectedIdsPeople}
                  setSelectedIds={arg => setSelectedIdsPeople(arg)}
                  setShowPopup={arg => setShowPopupPeople(arg)}
                  showPopup={showPopupPeople}
                  isLoadingEmailsHistory={isLoadingEmailsHistory}
                  emailsHistory={emailsHistory}
                />
              </div>,
              <div key={2} className="h-full">
                <TargetListCompanies
                  templates={templates}
                  isLoadingEmailsHistory={isLoadingEmailsHistory}
                  emailsHistory={emailsHistory}
                  project={project}
                  targetList={targetList}
                  targetContactIds={targetContactIds}
                  counters={companiesCounters}
                  toActivate={toActivateCompanies}
                  contacts={companiesContacts}
                  filters={companiesFilters}
                  setFilters={(action) => setCompaniesFilters({ ...companiesFilters, ...action, page: 0 })}
                  setPage={(page) => setCompaniesFilters({ ...companiesFilters, page })}
                  resetFilters={() => setCompaniesFilters(initialStateContactsFilters['target'][ContactType.COMPANY])}
                  selectedIds={selectedIdsCompanies}
                  setSelectedIds={arg => setSelectedIdsCompanies(arg)}
                  setShowPopup={arg => setShowPopupCompanies(arg)}
                  showPopup={showPopupCompanies}
                />
              </div>,
            ]}
            value={tab === 'specifics' ? 0 : tab === 'people' ? 1 : 2}
            setValue={(e) => {
              if (e === 0) {
                navigate(window.location.pathname.replace(/\/people|\/companies/, "/specifics"));
              }
              if (e === 1) {
                navigate(window.location.pathname.replace(/\/specifics|\/companies/, "/people"));
              }
              if (e === 2) {
                navigate(window.location.pathname.replace(/\/specifics|\/people/, "/companies"));
              }
            }}
          />
        </div>
      </div>
      {
        !window.location.pathname.includes("edit-project") && !keycloak.hasRealmRole('customer') &&
        // <AssociateCompanyModal /> TODO see if needed
        <></>
      }
    </div>
  );
}
